<template>
  <Page bg_color="bg-white">
    <v-img
      cover
      :src="login_bg_url"
      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    >
      <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="particles-bg-js"
      >
      </vue-particles>
      <CenterPageColumn :outlined="false" :has_nav_bar="true">
        <CenterNavbar
          :crumps="[]"
          title=""
          :width_class="page_info.center_width_class"
          bg_color=""
        ></CenterNavbar>
        <ContactPageBanner
          bg_url=""
          :has_nav_bar="true"
          id="activate_form_top"
          logo_class="logo-bg2"
        ></ContactPageBanner>

        <CardedForm
          style="max-width: 600px; margin: auto !important"
          ref="activate_form_ref"
          id="activate_form"
          title="Account Activation Form"
          :is_loading="is_loading"
          @on-submit-form="on_activate"
          :errors="errors"
          :message="message"
          @on-auto-fill="on_auto_fill"
          @on-close-message="on_hide_message"
        >
          <TextField
            v-model="form.code"
            :validation_rules="code_rules"
            label="Enter Activation Code"
            icon="mdi-padlock"
            :disabled="is_loading"
          ></TextField>
        </CardedForm>
      </CenterPageColumn>
    </v-img>

    <v-row class="ma-0 pa-0 bg-footer" no-gutters>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
      <v-col class="ma-0 pl-0 bg-footer" no-gutters>
        <Footer
          :is_loading="is_loading"
          @on-hide-loader="$emit('on-hide-loader')"
          @on-show-loader="$emit('on-show-loader')"
        ></Footer>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
    </v-row>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import Footer from "./../../components/CenterFooter";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import page_info from "./../../lib/page_info";
import ContactPageBanner from "./../../components/ContactPageBanner";
import CardedForm from "./../../components/CardedForm";
import TextField from "./../../components/TextField";

import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";

export default {
  name: "Activate",
  components: {
    Page,
    Footer,
    CenterPageColumn,
    ContactPageBanner,
    CenterNavbar,
    CardedForm,
    TextField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      login_bg_url:
        "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1602788555/botswana%20services/website%20assets/login_bg_qmbfxp.png",
      page_info: page_info,
      errors: [],
      message: "",
      form: {
        code: "",
      },
      code_rules: [
        Utils.validate.is_required("Activation code is required"),
        Utils.validate.numeric("Code should only be four numeric digits"),
        Utils.validate.length(
          4,
          "Activation code is expected to be four digits long"
        ),
      ],
      is_from_link: false
    };
  },
  methods: {
    on_auto_fill() {
      this.form.code = 4567;
    },
    on_activate() {
      //form is already validated
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Activate.activate_account(
        {
          code: this.form.code,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.$refs.activate_form_ref.on_clear_form();
          var msg =
            "<b>Account Activation Was Succesfull</b> <br/>  Thank you for joining  busyug.";
          msg =
            msg +
            " <br/><br/> <b class='success--text'>Your account is now active</b>, please login ...";
          this.message = msg;
          this.$refs.activate_form_ref.show_message_dialog();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.activate_form_ref.show_error_dialog();
        }
      );
    },
    on_hide_message(){
      this.$router.push('/login');
    }
  },
  mounted(){
    //console.log(this.$route.query);
    var q = this.$route.query;
    if(q && q.c){
      this.form.code = q.c;
      this.is_from_link = true;
      this.$refs.activate_form_ref.on_submit_form();
    }
  }
};
</script>